import { render } from "./ChatBotEA.vue?vue&type=template&id=3e2abd56&scoped=true"
import script from "./ChatBotEA.vue?vue&type=script&lang=js"
export * from "./ChatBotEA.vue?vue&type=script&lang=js"

import "./ChatBotEA.vue?vue&type=style&index=0&id=3e2abd56&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e2abd56"]])

export default __exports__